<template>
  <v-container class="d-flex-column justify-center">
    <v-card :loading="loading" class="mt-2">
      <v-card-title>
        <h1 class="mr-2 subheading grey--text">Πιστώσεις</h1>
        <v-spacer></v-spacer>
        <v-chip label>
          {{
            $tocurr(
              breakdown.cash + breakdown.bank + breakdown.check + breakdown.card
            )
          }}
        </v-chip>
        <v-container fluid class="mt-2">
          <v-row>
            <v-col cols="12" md="2">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Start date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu = false"
                  min="2021-11-01"
                  :events="functionEvents"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date2"
                    label="End date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date2"
                  @input="menu2 = false"
                  :events="functionEvents"
                  min="2021-11-01"
                  :max="
                    new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .substr(0, 10)
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" align="end">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-sheet class="mt-4">
            <v-row align="center" justify="space-around">
              <p class="text-body-2 font-weight-bold">
                <v-icon>mdi-bank-transfer-in</v-icon>
                {{ $tocurr(breakdown.bank) }}
              </p>
              <p class="text-body-2 font-weight-bold">
                <v-icon>mdi-credit-card-chip</v-icon>
                {{ $tocurr(breakdown.card) }}
              </p>
              <p class="text-body-2 font-weight-bold">
                <v-icon>mdi-cash-100</v-icon> {{ $tocurr(sumField(this.tabs, "TotalValue")) }}
              </p>
              <p class="text-body-2 font-weight-bold">
                <v-icon>mdi-cash-multiple</v-icon> {{ $tocurr(breakdown.cash-sumField(this.tabs, "TotalValue")) }}
              </p>
              <p class="text-body-2 font-weight-bold">
                <v-icon>mdi-checkbook</v-icon> {{ $tocurr(breakdown.check) }}
              </p>
            </v-row>
          </v-sheet>
        </v-container>
      </v-card-title>
    </v-card>
    <v-card class="mt-2">
      <v-tabs v-model="vtab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in vtabs" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items class="mt-2 pa-2" v-model="vtab">
      <v-tab-item :key="vtabs[0]">
        <v-row fluid class="d-flex">
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card class="mt-5" tile>
              <v-card-title>
                <h1 class="mr-2 subheading grey--text">Εισπράξεις</h1>
                <v-spacer />
                <v-chip label outlined>
                  {{ $tocurr(sumField(this.debits, "TotalValue")) }}
                </v-chip>
              </v-card-title>
              <invoice-table
                :search="search"
                :invoices="debits"
                :loading="loading"
              ></invoice-table>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card class="mt-5" tile>
              <v-card-title>
                <h1 class="mr-2 subheading grey--text">Καρτέλες</h1>
                <v-spacer />
                <v-chip label outlined>
                  {{ $tocurr(sumField(this.nonBill, "TotalValue")) }}
                </v-chip>
              </v-card-title>
              <invoice-table
                :search="search"
                :invoices="nonBill"
                :loading="loading"
              ></invoice-table>
            </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
            <v-card class="mt-5" tile>
              <v-card-title>
                <h1 class="mr-2 subheading grey--text">Tab</h1>
                <v-spacer />
                <v-chip label outlined>
                  {{ $tocurr(sumField(this.tabs, "TotalValue")) }}
                </v-chip>
              </v-card-title>
              <invoice-table
                :search="search"
                :invoices="tabs"
                :loading="loading"
              ></invoice-table>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :key="vtabs[1]">
        <v-card class="mt-4 mx-auto" max-width="100%">
          <v-sheet
            class="v-sheet--offset mx-auto"
            color="white"
            elevation="0"
            max-width="calc(100% - 32px)"
          >
            <apexchart
              ref="barChart"
              type="bar"
              height="500"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </v-sheet>
          <v-card-text class="pt-0">
            <div class="text-h6 font-weight-light mb-2">
              Εισπράξεις {{ currentYear - 2 }} - {{ currentYear - 1 }} -
              {{ currentYear }}
            </div>
            <div v-if="byMonth" class="subheading font-weight-light grey--text">
              Εισπράξεις ανά μήνα για το τρέχων έτος.
            </div>
            <div v-else class="subheading font-weight-light grey--text">
              Εισπράξεις ανά εβδομάδα για το τρέχων έτος.
            </div>
            <v-switch
              label="Ανάλυση ανά εμβδομάδα/μήνα."
              v-model="byMonth"
            ></v-switch>
            <v-divider class="my-2"></v-divider>
            <v-icon class="mr-2" small>mdi-delta</v-icon>
            <span class="text-caption grey--text font-weight-light"
              >Μέση τιμή {{ weeklyAvg }}</span
            >
            <v-divider class="my-2"></v-divider>
            <span class="text-caption grey--text font-weight-light"
              >{{ currentYear - 2 }}: {{ $tocurr(yearSums[0]) }}</span
            >
            <v-divider class="my-2"></v-divider>
            <span class="text-caption grey--text font-weight-light"
              >{{ currentYear - 1 }}: {{ $tocurr(yearSums[1]) }}</span
            >
            <v-divider class="my-2"></v-divider>
            <span class="text-caption grey--text font-weight-light"
              >{{ currentYear }}: {{ $tocurr(yearSums[2]) }}</span
            >
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import InvoiceTable from "../components/InvoiceTable.vue";
import VueApexCharts from "vue-apexcharts";

Date.prototype.getWeek = function () {
  var onejan = new Date(this.getFullYear(), 0, 1);
  return Math.ceil(((this - onejan) / 86400000 + onejan.getDay() + 1) / 7);
};

export default {
  components: {
    InvoiceTable,
    apexchart: VueApexCharts,
  },
  computed: {
    weeklyAvg() {
      var sum = 0;
      if (!this.weekly) return 0;
      for (var el in this.weekly) sum += this.weekly[el];
      return this.$tocurr(sum / Object.keys(this.weekly).length);
    },
    currentYear() {
      return new Date().getFullYear();
    },

    yearSums() {
      return this.series.map((yearData) =>
        yearData.data.reduce((a, b) => a + (b || 0), 0)
      );
    },
  },
  watch: {
    async date() {
      if (this.date != this.$route.query.startdate) {
        this.$router.replace({
          name: "Debits",
          query: { startdate: this.date, enddate: this.date2 },
        });
        await this.fetchData();
      }
    },
    async date2() {
      if (this.date2 != this.$route.query.enddate) {
        this.$router.replace({
          name: "Debits",
          query: { startdate: this.date, enddate: this.date2 },
        });
        await this.fetchData();
      }
    },
    byMonth() {
      this.updateChart();
    },
  },
  data() {
    return {
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      dialog: false,
      loading: true,
      debTotal: 0.0,
      tabTotal: 0.0,
      debits: [],
      tabs: [],
      nonBill: [],
      weekly: null,
      byMonth: 1,
      vtab: null,
      vtabs: ["Πινακες", "Γραφημα"],
      breakdown: { cash: 0, card: 0, check: 0, bank: 0 },
      menu: false,
      menu2: false,
      search: "",

      series: [
        {
          name: "Debits",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
          stacked: false,
        },
        plotOptions: {
          bar: {
            columnWidth: "85%",
            borderRadius: 0,
            dataLabels: {
              position: "top", // top, center, bottom
              orientation: "vertical",
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: this.$tocurr,
          offsetY: 15,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
            textAnchor: "start",
          },
        },
        xaxis: {
          type: "datetime",
          categories: [],
          position: "bottom",
          axisBorder: {
            show: true,
            color: "#78909C",
          },
          axisTicks: {
            show: true,
            color: "#78909C",
          },
          labels: {
            rotate: -45,
            style: {
              fontSize: "12px",
              colors: ["#78909C"],
            },
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                return "$ " + val + " thousands";
              },
            },
          },
        },
        legend: {
          position: "top",
          show: true,
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: true,
          },
          labels: {
            show: true,
            formatter: this.$tocurr,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    await this.fetchData();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    async fetchData() {
      this.loading = true;
      const currentYear = new Date().getFullYear();
      const previousYear1 = currentYear - 1;
      const previousYear2 = currentYear - 2;

      try {
        let currentYearResponse = await this.$api.get("/customers/debits/", {
          params: {
            start_date: this.date,
            end_date: this.date2,
            breakdown: true,
            weekly: currentYear,
          },
        });
        let previousYear2Response = await this.$api.get("/customers/debits/", {
          params: {
            weekly: previousYear2,
          },
        });
        let previousYear1Response = await this.$api.get("/customers/debits/", {
          params: {
            weekly: previousYear1,
          },
        });

        this.nonBilling = currentYearResponse.data.NonBilling;
        this.debits = currentYearResponse.data.Debs;
        this.tabs = currentYearResponse.data.Tabs;
        this.breakdown = currentYearResponse.data.Breakdown;
        this.currentYearWeekly = currentYearResponse.data.ByWeek;
        this.previousYear1Weekly = previousYear2Response.data.ByWeek;
        this.previousYear2Weekly = previousYear1Response.data.ByWeek;
        this.updateChart();
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    functionEvents(date) {
      return this.debits.some((e) => e.Date == date);
    },
    sumField(items, key) {
      return items.reduce(
        (accumulator, item) => accumulator + (item[key] || 0),
        0
      );
    },
    updateChart() {
      let labels = [];
      let weekIndex = 0;

      if (this.byMonth) {
        let chartData = [
          { data: [], name: `${new Date().getFullYear() - 2}` },
          { data: [], name: `${new Date().getFullYear() - 1}` },
          { data: [], name: `${new Date().getFullYear()}` },
        ];
        let sumCurrentYear = 0;
        let sumPreviousYear1 = 0;
        let sumPreviousYear2 = 0;

        const previousYear1Values = Object.values(this.previousYear1Weekly);
        const previousYear2Values = Object.values(this.previousYear2Weekly);
        const currentYearValues = Object.values(this.currentYearWeekly).concat(
          Array(previousYear2Values.length)
            .fill(0)
            .slice(0, previousYear2Values.length)
        );

        for (const [key] of Object.entries(this.previousYear1Weekly)) {
          /*   if (weekIndex % 4) {
            sumCurrentYear += currentYearValues[weekIndex - 1];
            sumPreviousYear1 += previousYear1Values[weekIndex - 1];
            sumPreviousYear2 += previousYear2Values[weekIndex - 1];
          } else {
            labels.push((new Date(key)).toLocaleString('default', { month: 'short' }));
            chartData[2].data.push(sumCurrentYear);
            chartData[1].data.push(sumPreviousYear1);
            chartData[0].data.push(sumPreviousYear2);
            sumCurrentYear = 0;
            sumPreviousYear1 = 0;
            sumPreviousYear2 = 0;
          }
          weekIndex += 1; */
          sumCurrentYear += currentYearValues[weekIndex];
          sumPreviousYear1 += previousYear1Values[weekIndex];
          sumPreviousYear2 += previousYear2Values[weekIndex];

          if (
            (weekIndex + 1) % 4 === 0 ||
            weekIndex === previousYear1Values.length - 1
          ) {
            labels.push(
              new Date(key).toLocaleString("default", { month: "short" })
            );
            chartData[2].data.push(sumCurrentYear);
            chartData[1].data.push(sumPreviousYear1);
            chartData[0].data.push(sumPreviousYear2);
            sumCurrentYear = 0;
            sumPreviousYear1 = 0;
            sumPreviousYear2 = 0;
          }
          weekIndex += 1;
        }
        this.series = chartData;
        this.chartOptions.xaxis = {
          type: "category",
          categories: labels,
          position: "bottom",
        };
      } else {
        let chartData = [
          { data: [], name: `${new Date().getFullYear() - 2}` },
          { data: [], name: `${new Date().getFullYear() - 1}` },
          { data: [], name: `${new Date().getFullYear()}` },
        ];

        weekIndex = Object.keys(this.previousYear1Weekly).length;
        for (const value of Object.values(this.previousYear1Weekly)) {
          chartData[0].data.push(value);
          weekIndex -= 1;
          if (weekIndex == 0) break;
        }

        weekIndex = Object.keys(this.previousYear2Weekly).length;
        for (const value of Object.values(this.previousYear2Weekly)) {
          chartData[1].data.push(value);
          weekIndex -= 1;
          if (weekIndex == 0) break;
        }

        for (let date in this.currentYearWeekly) {
          labels.push(date);
          chartData[2].data.push(this.currentYearWeekly[date]);
        }
        this.series = chartData;
        this.chartOptions.xaxis = {
          type: "category",
          categories: labels,
          position: "bottom",
        };
      }
    },
  },
};
</script>
<style scoped>
.v-sheet--offset {
  padding: 16px;
}
</style>
<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>
